<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="clearSearchFilter()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date d'import</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromDate"
              [valueFrom]="fromDate"
              typeTo="ToDate"
              [valueTo]="toDate"></custom-date-range-input>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-table
  [data]="imports"
  [tableActions]="tableActions"
  [tableIndications]="tableIndications"
  [onClearFilters]="onClearFilters"
  [exportFileName]="exportFileName"
  [columnsDefinition]="columnsDefinition"
  [showClearFilterButton]="true"
  [configKey]="configKey"
  [onExportExcelCaller]="onExportExcelCaller"
  [onFiltersCleared]="onFiltersCleared"
  ngDefaultControl>
</app-table>
